import React, { Component } from "react"
import { Link } from "gatsby"

class WidgetSection extends Component {
  render() {
    return (
      <section className="footer-widget-section">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-sm-6 p-lg-2 p-md-0">
              <img
                className="img-fluid"
                src={require("../../../static/logos/black-logo.png")}
              />
            </div>

            <div className="col-md-3 col-sm-6 p-lg-2 p-md-0">
              <div className="widget">
                <h3>Our Services</h3>
                <ul>
                  <li>
                    <Link to="/services">SEO Marketing</Link>
                  </li>
                  <li>
                    <Link to="/services">Web Developement</Link>
                  </li>
                  <li>
                    <Link to="/services">Mobile Applications</Link>
                  </li>
                  <li>
                    <Link to="/services">Application Developement</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 p-lg-2 p-md-0">
              <div className="widget">
                <h3>Quick Links</h3>
                <ul>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/our-portfolio">Portfolio</Link>
                  </li>
                  <li>
                    <Link to="/about-us">About us</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Contact us</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 p-lg-2 p-md-0">
              <div className="widget">
                <h3>Address</h3>
                <div className="textwidget">
                  <i className="fa fa-building" /> Morosoft
                  <br />
                  <i className="fa fa-map" /> Office S#16, E-8 Markaz Plaza,
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hyderi Chowk, Saidpur Road,
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Rawalpindi
                  <br />
                  <i className="fa fa-envelope" />
                  <a href="mailto:info@morosoft.org" className="footer-email">
                    {" "}
                    info@morosoft.org
                  </a>
                  <br />
                  <i className="fa fa-phone" /> +92 334 3868945
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default WidgetSection
